import { render, staticRenderFns } from "./entityReles.vue?vue&type=template&id=ba428d68&scoped=true&"
import script from "./entityReles.vue?vue&type=script&lang=js&"
export * from "./entityReles.vue?vue&type=script&lang=js&"
import style0 from "./entityReles.vue?vue&type=style&index=0&id=ba428d68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba428d68",
  null
  
)

component.options.__file = "entityReles.vue"
export default component.exports